module.exports = __webpack_public_path__ + "img/time_between_icon.1d1c8912.svg";